import { useCallback, useLayoutEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ROUTE_HOME } from 'src/lib'

export const useIsOnTopOfPage = () => {
  const { pathname } = useLocation()
  const isHomePage = pathname === ROUTE_HOME
  const [isOnTopOfPage, setIsOnTopOfPage] = useState<boolean>(true)
  const ref = useRef<HTMLDivElement>(null)
  const calculateShowInfo = useCallback(() => {
    if (!ref.current) return
    setIsOnTopOfPage(isHomePage && ref.current.scrollTop < 120)
  }, [isHomePage])

  useLayoutEffect(() => {
    calculateShowInfo()
    if (!isHomePage) return
    if (ref.current) {
      ref.current.addEventListener('scroll', calculateShowInfo)
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener('scroll', calculateShowInfo)
      }
    }
  }, [isHomePage])

  return { isOnTopOfPage, ref }
}
